import React from "react";
import { Droplet, Wrench, FileText, BellRing, ArrowUpRight } from "lucide-react";

const services = [
  {
    id: "testing",
    icon: Droplet,
    title: "Backflow Testing",
    desc: "Annual certified testing on RPZ, DC, PVB and DCDA devices. Reports filed directly with the City of Laredo.",
    bullets: ["Same-day reports", "All device types", "Digital + paper filing"],
  },
  {
    id: "install",
    icon: Wrench,
    title: "Installation & Repair",
    desc: "New backflow assembly installation and repair for residential, commercial, and irrigation systems.",
    bullets: ["Warrantied parts", "Emergency repair", "Code compliance"],
  },
  {
    id: "city",
    icon: FileText,
    title: "City of Laredo Filing",
    desc: "We handle registration, paperwork, and annual compliance submissions to the city on your behalf.",
    bullets: ["City-approved tester", "Paperwork handled", "Compliance tracking"],
  },
  {
    id: "reminders",
    icon: BellRing,
    title: "Re-certification Reminders",
    desc: "Never miss a test window again. We track your device and remind you 30 days before your annual is due.",
    bullets: ["Auto text reminders", "Email alerts", "Zero late fees"],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 lg:py-28" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="step-num">01 — WHAT WE DO</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold mt-3 tracking-tight">
              Full-service backflow, from test to filing.
            </h2>
          </div>
          <p className="md:max-w-sm text-slate-600">
            Whether you got a city notice, need a new install, or run a property management company — we
            handle the whole job.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-l border-t border-slate-200">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                className="svc-card p-6 lg:p-8 bg-white border-r border-b border-slate-200"
                data-testid={`service-card-${s.id}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 border border-slate-900 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-slate-900" />
                  </div>
                  <span className="font-display text-xs text-slate-400">0{i + 1}</span>
                </div>
                <h3 className="font-display text-xl font-bold mt-5 tracking-tight">{s.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.desc}</p>
                <ul className="mt-4 space-y-1.5">
                  {s.bullets.map((b) => (
                    <li key={b} className="text-[13px] text-slate-700 flex items-center gap-2">
                      <span className="w-1 h-1 bg-orange-500"></span> {b}
                    </li>
                  ))}
                </ul>
                <a
                  href="#booking"
                  className="mt-5 inline-flex items-center gap-1 text-sm font-display font-semibold text-blue-600"
                >
                  Book this service <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
